// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'page-accessibility-wcag2-0-table',
    standalone: false,
    template: `
        <div class="card panel-monsido-card">
            <div class="card-header">
                <div class="d-flex mt-2">
                    <div class="d-flex align-items-center">
                        <span class="mr-2 fa-2x" [class]="headerIcon"></span>
                    </div>
                    <div class="mr-auto d-flex align-items-center">
                        <h2 class="font-weight-300 mb-1 mt-0">
                            {{ header }}
                        </h2>
                    </div>
                    <div>
                        <table-compliance
                                class="inline-block pr-2 minimize-compliance-txt"
                                [data]="[passedChecks, errorChecks]"
                                [labels]="['', '']"
                                size="46"
                                [btnWord]="'Overall accessibility compliance for this level' | translate"
                                [indexNumber]="0">
                        </table-compliance>
                    </div>
                </div>
            </div>
            <div class="card-body px-0">
                <table class="table table-hover table-fixed seo-issues">
                    <thead>
                    <tr>
                        <th class="col-sm-8 col-md-6 col-lg-4"></th>
                        <th class="col-sm-24 col-md-28 col-lg-34" translate>Checks</th>
                        <th class="col-sm-18 col-md-14 col-lg-10 text-right">
                            <span class="pr-3" translate>Individual issues</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr [class.selected]="checkItem.id === selectedCheck?.id"
                        role="button"
                        (click)="onSelectCheck(checkItem)"
                        *ngFor="let checkItem of getChecks()">
                        <td class="text-v-middle">
                            <mon-table-policy-type
                                class="inline-block pl-3 py-1"
                                [color]="checkItem.ignored ? 'grey' : iconColor"
                                [isMobileCheck]="checkItem.mobile"
                                [passed]="checkItem.errors_count === 0 && !checkItem.ignored"
                                [target]="checkItem.result_type"
                                [tooltip]="checkItem.result_type | capitalize">
                            </mon-table-policy-type>
                        </td>
                        <td class="text-v-middle">
                            <div [attr.data-test]="'check-id-' + checkItem.id"
                                 [class.text-grey]="checkItem.errors_count === 0 || checkItem.ignored"
                                 [innerHTML]="checkItem.name"></div>
                            <acc-responsibilities [responsibilities]="checkItem.responsibilities" [icon]="true"></acc-responsibilities>
                            <acc-guideline-description [check]="checkItem"></acc-guideline-description>
                        </td>
                        <td class="text-right text-v-middle">
                            <span *ngIf="checkItem.errors_count > 0 && !checkItem.ignored" class="pr-3">{{ checkItem.errors_count }}</span>
                            <span class="text-success" *ngIf="checkItem.errors_count === 0 && !checkItem.ignored" translate>Check passed</span>
                            <span class="text-grey" *ngIf="checkItem.ignored" translate>Check is ignored</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `,
})
export class PageAccessibilityWcag20TableComponent implements OnInit {
    @Input() issues: any[] = [];
    @Input() iconColor: string = '';
    @Input() header: string = '';
    @Input() headerIcon: string = '';
    @Input() check: any;
    @Input() tab: string = '';
    @Input() active: any;
    @Input() progress: any;

    @Output() selectCheck = new EventEmitter<{ check: any }>();

    passedChecks: number = 0;
    errorChecks: number = 0;
    selectedCheck: any;

    ngOnInit (): void {
        this.issues = this.issues || [];

        Promise.resolve(this.progress).finally(() => {
            setTimeout(() => {
                if (this.active !== null) {
                    const selectedCheck = this.issues.find((checkItem) => {
                        return checkItem.id === this.active;
                    });
                    if (selectedCheck) {
                        this.onSelectCheck(selectedCheck);
                    }
                }
                this.passedChecks = this.issues.length - this.getChecksWithIssuesCount();
                this.errorChecks = this.getChecksWithIssuesCount();
            });
        });
    }

    onSelectCheck (check: any): void {
        this.selectedCheck = check;
        this.selectCheck.emit({ check });
    }

    getChecksWithIssuesCount (): number {
        if (!Array.isArray(this.issues)) {
            return 0;
        }

        return this.issues.reduce((num, issue) => {
            if (issue.errors_count > 0 && !issue.ignored && !issue.ignored_on_page) {
                num++;
            }
            return num;
        }, 0);
    }

    getChecks (): any[] {
        if (!Array.isArray(this.issues)) {
            return [];
        }
        return this.issues.filter((data) => {
            if (this.tab === 'passed_checks') {
                return data.errors_count === 0 && !data.ignored;
            } else if (this.tab === 'ignored_issues') {
                return data.ignored;
            } else {
                return data.errors_count > 0;
            }
        });
    }
}
